import * as ecModels from '../../../../models'

export interface SourceParams {
  /**
   * @default Target.DEFAULT
   * @see {@link ecModels.Target}
   */
  readonly target?: ecModels.Target
  /**
   *  Official or proposed selections
   *
   * @default 'applied'
   */
  readonly from?: 'edited' | 'applied'
}
export namespace SourceParams {
  /**
   * Create a {@link SourceParams} with default values.
   */
  export function withDefaults(params: SourceParams): Required<SourceParams> {
    return {
      from: 'applied',
      target: ecModels.Target.DEFAULT,
      ...params,
    }
  }
}
